export class Constants {
    static readonly appVersion: string = '2.0.0';
    static readonly baseUrl: string = 'https://cablenote.com/rest/v10/cn';
    //static readonly baseUrl: string = 'http://localhost:7080/CableNotes/rest/v10/cn';

    constructor() {

    }
}